import * as filestack from 'filestack-js';

class Uploader {
    private readonly path: string;
    private readonly companyId: string;
    private readonly campaignId: string;
    private readonly workflowId: string;
    private readonly downloadUrl: string;
    private onProgress: any;
    private client: any;

    constructor(companyId: string, campaignId: string) {
        this.path = `/${companyId}/${campaignId}/`;
        this.companyId = companyId;
        this.campaignId = campaignId;
        this.client = filestack.init(import.meta.env.VITE_FILESTACK_KEY);
        this.workflowId = import.meta.env.VITE_FILESTACK_WORKFLOW_ID;
        this.downloadUrl = import.meta.env.VITE_DOWNLOAD_URL;
    }

    async upload(file: File) {
        const options = {
            onProgress: this.onProgress,
            tags: {
                companyId: this.companyId,
                campaignId: this.campaignId,
            },
        };

        const storeOptions = {
            location: 's3',
            path: this.path,
            workflows: [this.workflowId],
        };

        const response = await this.client.upload(file, options, storeOptions);
        const { jobid } = response.workflows[this.workflowId];

        return `${this.downloadUrl}/${jobid}`;
    }
}

export default Uploader;
